import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { LoyaltyPointEventTypeToken } from '@sleed/bizcommerce-api';
import { pointsPerEntityApi } from '~/lib/api/client';
import { formToToken, type LoyaltyEventTypeFormValues } from '~/lib/schemas/loyalty-event-type';

export const loyaltyPerEntityKeys = {
	all: ['loyalty-per-entity'] as const,
	list: () => [...loyaltyPerEntityKeys.all, 'list'] as const
};

export function useLoyaltyPerEntityList() {
	return useQuery<LoyaltyPointEventTypeToken[]>({
		queryKey: loyaltyPerEntityKeys.list(),
		queryFn: async () => (await pointsPerEntityApi.getAll()).data.items ?? []
	});
}

export function useLoyaltyPerEntityMutations() {
	const qc = useQueryClient();
	const update = useMutation({
		mutationFn: async (form: LoyaltyEventTypeFormValues) => (await pointsPerEntityApi.update(formToToken(form))).data,
		onSuccess: () => qc.invalidateQueries({ queryKey: loyaltyPerEntityKeys.list() })
	});
	return { update };
}
